import qs from 'qs';
import { api, publicApi } from 'src/api/api';
import { StrapiResponse } from 'src/types/http';

type GetFiagroRankingsParams = {
  type?: string | null;
  criteria?: string | null;
  year?: string | null;
  timeRange?: string | null;
  keyword?: string;
  page?: number;
  pageSize?: number;
  sortBy?: string;
  sortOrder?: 'asc' | 'desc';
  isLoggedIn: boolean;
};

export const getFiagroRankings = async ({
  type,
  criteria,
  year,
  timeRange,
  keyword,
  page = 1,
  pageSize = 20,
  sortBy = 'position',
  sortOrder = 'asc',
  isLoggedIn,
}: GetFiagroRankingsParams): Promise<StrapiResponse<any[]>> => {
  const query = qs.stringify(
    {
      type,
      criteria,
      year,
      timeRange,
      keyword,
      page,
      pageSize,
      sortBy,
      sortOrder,
    },
    { encodeValuesOnly: true },
  );

  const client = isLoggedIn ? api : publicApi;

  const { data } = await client.get<StrapiResponse<any[]>>(
    `/meta-fiagro-rankings-plataforma/fiagro-rankings?${query}`,
  );

  return data;
};
